export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'f0f6fa8', dateTime: 1786547295527 };